export const data = [
    {
        polarisation: {
            title: 'Breakdown of Polarisation Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given polarisation indicator group (i.e. it is less polarised on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given polarisation indicator group (i.e. it is more polarised on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [
                {
                    title: '1. POLITICAL INJUSTICE',
                    description: 'Political Injustice scores are derived from a measure of the perceived lack of laws protecting ethnic minorities from discrimination.',
                    source: 'Figure 20 from the EU-MIDIS II Written Report (2016, p. 55)',
                    dataNames: ['Political Injustice Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.47
                        },
                        {
                            name: 'DNK',
                            'v1': 0.11
                        },
                        {
                            name: 'FRA',
                            'v1': -0.82
                        },
                        {
                            name: 'DEU',
                            'v1': -0.34
                        },
                        {
                            name: 'GRC',
                            'v1': 0.06
                        },
                        {
                            name: 'HUN',
                            'v1': 1.8
                        },
                        {
                            name: 'ITA',
                            'v1': 1.77
                        },
                        {
                            name: 'NLD',
                            'v1': -0.47
                        },
                        {
                            name: 'POL',
                            'v1': -0.87
                        },
                        {
                            name: 'UK',
                            'v1': -0.78
                        }
                    ]
                },
                {
                    title: '2. MAINSTREAM ENGAGEMENT',
                    description: 'Mainstream Disengagement scores are derived from measures of ethnic minority distrust in a country`s parliament, legal system, police, politicians, and political parties. The score further includes a measure of the number of ethnic minority individuals within a country stating no interest in politics.',
                    source: 'EU MIDIS II Database (2016)',
                    dataNames: ['Mainstream Disengagement Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.05
                        },
                        {
                            name: 'DNK',
                            'v1': 0.28
                        },
                        {
                            name: 'FRA',
                            'v1': 0.28
                        },
                        {
                            name: 'DEU',
                            'v1': -1.43
                        },
                        {
                            name: 'GRC',
                            'v1': -0.07
                        },
                        {
                            name: 'HUN',
                            'v1': 1.7
                        },
                        {
                            name: 'ITA',
                            'v1': 0.61
                        },
                        {
                            name: 'NLD',
                            'v1': 0.33
                        },
                        {
                            name: 'POL',
                            'v1': -0.66
                        },
                        {
                            name: 'UK',
                            'v1': -0.99
                        }
                    ]
                },
                {
                    title: '3. ANTAGONISTIC ENVIRONMENT',
                    description: 'Antagonistic Environment scores are derived from measures of surveyed ethnic minority individuals who have experienced in-person harassment or physical attacks.',
                    source: 'EU MIDIS II Database (2016)',
                    dataNames: ['Antagonistic Environment Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.25
                        },
                        {
                            name: 'DNK',
                            'v1': 0.38
                        },
                        {
                            name: 'FRA',
                            'v1': 0.07
                        },
                        {
                            name: 'DEU',
                            'v1': 0.62
                        },
                        {
                            name: 'GRC',
                            'v1': 1.11
                        },
                        {
                            name: 'HUN',
                            'v1': -0.74
                        },
                        {
                            name: 'ITA',
                            'v1': -0.81
                        },
                        {
                            name: 'NLD',
                            'v1': 0.7
                        },
                        {
                            name: 'POL',
                            'v1': -0.7
                        },
                        {
                            name: 'UK',
                            'v1': -1.24
                        }
                    ]
                },
                {
                    title: '4. ONLINE POLARISATION',
                    description: 'Online Polarisation scores are derived from a measure of surveyed ethnic minority individuals who have experienced cyber-harassment.',
                    source: 'EU MIDIS II Database (2016)',
                    dataNames: ['Online Polarisation Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.21
                        },
                        {
                            name: 'DNK',
                            'v1': 0.75
                        },
                        {
                            name: 'FRA',
                            'v1': 0.21
                        },
                        {
                            name: 'DEU',
                            'v1': 0.75
                        },
                        {
                            name: 'GRC',
                            'v1': -1.15
                        },
                        {
                            name: 'HUN',
                            'v1': -0.61
                        },
                        {
                            name: 'ITA',
                            'v1': -0.77
                        },
                        {
                            name: 'NLD',
                            'v1': 2.1
                        },
                        {
                            name: 'POL',
                            'v1': -0.61
                        },
                        {
                            name: 'UK',
                            'v1': -0.88
                        }
                    ]
                },
                {
                    title: '5. EXCLUSIONARY IDENTITIES',
                    description: 'Exclusionary Identity scores are derived from measures of the level of discomfort felt by the general public in relation to having an ethnic minority political leader, working with ethnic minority individuals, or involvement in ethnic minority relationships. The scores further include measures of discomfort felt amongst ethnic minorities in relation to having a neighbour of a differing minority background, or no minority background.',
                    source: 'EC Special Eurobarometer Report on Discrimination (2015, pp. 20, 22 and 24); EU MIDIS II Database (2016)',
                    dataNames: ['Exclusionary Identities Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.44
                        },
                        {
                            name: 'DNK',
                            'v1': -0.37
                        },
                        {
                            name: 'FRA',
                            'v1': -0.92
                        },
                        {
                            name: 'DEU',
                            'v1': 0.3
                        },
                        {
                            name: 'GRC',
                            'v1': 1.85
                        },
                        {
                            name: 'HUN',
                            'v1': 0.85
                        },
                        {
                            name: 'ITA',
                            'v1': 0.38
                        },
                        {
                            name: 'NLD',
                            'v1': -0.71
                        },
                        {
                            name: 'POL',
                            'v1': 0.12
                        },
                        {
                            name: 'UK',
                            'v1': -1.06
                        }
                    ]
                },
                {
                    title: '6. DISCRIMINATION',
                    description: 'Discrimination scores are derived from measures of perceived levels of ethnic minority discrimination, feelings of being discriminated against, experiences of ethnic minority discrimination, ethnic minority perceptions of discrimination based on race or ethnicity, and feelings that one’s group are discriminated against on the grounds of race or ethnicity.',
                    source: 'EC Special Eurobarometer Report on Discrimination (2015, pp. 16, T2 and 70); EU MIDIS II Database (2016); European Social Survey (ESS)',
                    dataNames: ['Descrimination Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0
                        },
                        {
                            name: 'DNK',
                            'v1': 0.02
                        },
                        {
                            name: 'FRA',
                            'v1': 0.83
                        },
                        {
                            name: 'DEU',
                            'v1': -0.18
                        },
                        {
                            name: 'GRC',
                            'v1': -0.13
                        },
                        {
                            name: 'HUN',
                            'v1': 0.03
                        },
                        {
                            name: 'ITA',
                            'v1': -0.19
                        },
                        {
                            name: 'NLD',
                            'v1': 0.78
                        },
                        {
                            name: 'POL',
                            'v1': -1.52
                        },
                        {
                            name: 'UK',
                            'v1': 0.35
                        }
                    ]
                },
                {
                    title: '7. LACK OF INTER-GROUP CONTACT',
                    description: 'Lack of Inter-Group Contact scores are derived from measures of a comparative lack of individuals who identify as being a member of an ethnic minority group and a measure of the number of languages spoken within the country’s capital city.',
                    source: 'European Social Survey (ESS); Lamanna, F., Lenormand, M., Salas-Olmedo, M. H., Romanillos, G., Gonçalves, B., & Ramasco, J. J. (2018). Immigrant community integration in world cities. PloS one, 13(3).',
                    dataNames: ['Lack of Inter-Group Contact Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.04
                        },
                        {
                            name: 'DNK',
                            'v1': -1.06
                        },
                        {
                            name: 'FRA',
                            'v1': 0.3
                        },
                        {
                            name: 'DEU',
                            'v1': 1.04
                        },
                        {
                            name: 'GRC',
                            'v1': -0.93
                        },
                        {
                            name: 'HUN',
                            'v1': -0.9
                        },
                        {
                            name: 'ITA',
                            'v1': 0.64
                        },
                        {
                            name: 'NLD',
                            'v1': -0.04
                        },
                        {
                            name: 'POL',
                            'v1': 0.16
                        },
                        {
                            name: 'UK',
                            'v1': -0.54
                        }
                    ]
                }
            ]
        },
        resilience: {
            title: 'Resilience versus Non-Resilience Scores across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given resilience indicator group (i.e. it is less resilient on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given resilience indicator group (i.e. it is more resilient on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [{
                    title: '1. POSITIVE WELL-BEING',
                    description: 'Positive Well-Being scores are derived from measures of the extent to which those identifying as a member of an ethnic minority group rate themselves as being happy, as having someone they can discuss intimate personal matters with, as having a good standard of general health, and as engaging in social activities.',
                    source: 'European Social Survey (ESS)',
                    dataNames: ['Positive Well-Being Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.06
                        },
                        {
                            name: 'DNK',
                            'v1': 0.82
                        },
                        {
                            name: 'FRA',
                            'v1': 0.6
                        },
                        {
                            name: 'DEU',
                            'v1': 0.4
                        },
                        {
                            name: 'GRC',
                            'v1': -1.62
                        },
                        {
                            name: 'HUN',
                            'v1': -0.68
                        },
                        {
                            name: 'ITA',
                            'v1': -0.4
                        },
                        {
                            name: 'NLD',
                            'v1': 0.46
                        },
                        {
                            name: 'POL',
                            'v1': 0.54
                        },
                        {
                            name: 'UK',
                            'v1': -0.06
                        }
                    ]
                },
                {
                    title: '2. COMMUNITY ENGAGEMENT',
                    description: 'Community Engagement scores are derived from measures relating to the effectiveness of national efforts to tackle ethnic discrimination, the lack of exclusion of ethnic minorities from efforts to tackle economic crises, and ethnic minority awareness of organisations and equality bodies offering discrimination support.',
                    source: 'EC Special Eurobarometer Report on Discrimination (2015, pp. 89 and 94); EU MIDIS II Written Report (2016, pp. 51 and 54)',
                    dataNames: ['Community Engagement Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.71
                        },
                        {
                            name: 'DNK',
                            'v1': 0.78
                        },
                        {
                            name: 'FRA',
                            'v1': 0.31
                        },
                        {
                            name: 'DEU',
                            'v1': 0.13
                        },
                        {
                            name: 'GRC',
                            'v1': -1.07
                        },
                        {
                            name: 'HUN',
                            'v1': -0.88
                        },
                        {
                            name: 'ITA',
                            'v1': -1.23
                        },
                        {
                            name: 'NLD',
                            'v1': 0.42
                        },
                        {
                            name: 'POL',
                            'v1': 0.41
                        },
                        {
                            name: 'UK',
                            'v1': 0.71
                        }
                    ]
                },
                {
                    title: '3. SOCIAL INCLUSION',
                    description: 'Social Inclusion scores are derived from a measure of the membership rating of migrants in political parties within the country. Positive scores indicate a higher than average number of migrant members, while negative scores indicate a lower than average number of migrant members.',
                    source: 'MIPEX Database (2014)',
                    dataNames: ['Social Inclusion Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -1.69
                        },
                        {
                            name: 'DNK',
                            'v1': -0.40
                        },
                        {
                            name: 'FRA',
                            'v1': 0.19
                        },
                        {
                            name: 'DEU',
                            'v1': -0.87
                        },
                        {
                            name: 'GRC',
                            'v1': 1.13
                        },
                        {
                            name: 'HUN',
                            'v1': 1.13
                        },
                        {
                            name: 'ITA',
                            'v1': -0.28
                        },
                        {
                            name: 'NLD',
                            'v1': -0.63
                        },
                        {
                            name: 'POL',
                            'v1': 1.48
                        },
                        {
                            name: 'UK',
                            'v1': -0.05
                        }
                    ]
                },
                {
                    title: '4. DEMOCRATIC REPORTING',
                    description: 'Democratic Reporting scores are derived from measures relating to the perception of sufficient ethnic minority representation in the media, classification of the country’s media as democratic or liberal, and the country’s media and political discourse having not been rated as containing incitement against ethnic minorities or refugees and migrants.',
                    source: 'EC Special Eurobarometer Report on Discrimination (2015, p. T111); STOA Report on Polarisation and the News Media in Europe (2019, p. 15); FRA Report on Incitement in Media Content and Political Discourse in EU Member States (2016, pp. 7-9 and pp. 9-11)',
                    dataNames: ['Democratic Reporting Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 1
                        },
                        {
                            name: 'DNK',
                            'v1': 0.75
                        },
                        {
                            name: 'FRA',
                            'v1': -0.6
                        },
                        {
                            name: 'DEU',
                            'v1': 0.65
                        },
                        {
                            name: 'GRC',
                            'v1': -0.75
                        },
                        {
                            name: 'HUN',
                            'v1': -0.13
                        },
                        {
                            name: 'ITA',
                            'v1': -0.65
                        },
                        {
                            name: 'NLD',
                            'v1': 0.28
                        },
                        {
                            name: 'POL',
                            'v1': -1.16
                        },
                        {
                            name: 'UK',
                            'v1': 1
                        }
                    ]
                },
                {
                    title: '5. COMMUNITY COHESION',
                    description: 'Community Cohesion scores are derived from measures of ethnic minority individuals having friends from other ethnic minority backgrounds or no minority background, as well as individuals more generally having friends from a different ethnic group.',
                    source: 'EU MIDIS II Database (2016); EC Special Eurobarometer Report on Discrimination (2012, p. T91)',
                    dataNames: ['Community Cohesion Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.7
                        },
                        {
                            name: 'DNK',
                            'v1': 0.62
                        },
                        {
                            name: 'FRA',
                            'v1': -0.95
                        },
                        {
                            name: 'DEU',
                            'v1': 0.21
                        },
                        {
                            name: 'GRC',
                            'v1': -0.88
                        },
                        {
                            name: 'HUN',
                            'v1': -0.88
                        },
                        {
                            name: 'ITA',
                            'v1': -0.29
                        },
                        {
                            name: 'NLD',
                            'v1': 0.27
                        },
                        {
                            name: 'POL',
                            'v1': -1.38
                        },
                        {
                            name: 'UK',
                            'v1': 0.7
                        }
                    ]
                },
                {
                    title: '6. SUPPORTIVE ENVIRONMENT',
                    description: 'Supportive Environment scores are derived from measures relating to support for work place training on diversity, recruitment monitoring, and composition monitoring, perception of efforts to promote ethnic diversity in the workplace, agreement with new measures to protect ethnic minorities from discrimination, agreement that school lessons should include information on diversity, awareness of campaigns against the discrimination of ethnic minorities, agreement that immigrants contribute to the country, and agreement that one’s country should help refugees.',
                    source: 'EC Special Eurobarometer Report on Discrimination (2015, pp. 83, T82, 91 and 101); EU MIDIS II Database (2016); EC Standard Eurobarometer 89 Report (2018, pp. 76, 79)',
                    dataNames: ['Supportive Environment Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 1.17
                        },
                        {
                            name: 'DNK',
                            'v1': 0.38
                        },
                        {
                            name: 'FRA',
                            'v1': 0.05
                        },
                        {
                            name: 'DEU',
                            'v1': 0.13
                        },
                        {
                            name: 'GRC',
                            'v1': 0.27
                        },
                        {
                            name: 'HUN',
                            'v1': -0.92
                        },
                        {
                            name: 'ITA',
                            'v1': -0.27
                        },
                        {
                            name: 'NLD',
                            'v1': 0.28
                        },
                        {
                            name: 'POL',
                            'v1': -1.2
                        },
                        {
                            name: 'UK',
                            'v1': 1.17
                        }
                    ]
                },
                {
                    title: '7. POSITIVE IMAGE ONLINE',
                    description: 'Positive Image Online scores are derived from a measure of ethnic minority individuals not finding offensive comments on the internet over a 12-month period.',
                    source: 'EU MIDIS II Database (2016)',
                    dataNames: ['Positive Image Online Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.85
                        },
                        {
                            name: 'DNK',
                            'v1': -0.4
                        },
                        {
                            name: 'FRA',
                            'v1': -0.4
                        },
                        {
                            name: 'DEU',
                            'v1': -0.4
                        },
                        {
                            name: 'GRC',
                            'v1': 1.17
                        },
                        {
                            name: 'HUN',
                            'v1': 0.54
                        },
                        {
                            name: 'ITA',
                            'v1': 0.75
                        },
                        {
                            name: 'NLD',
                            'v1': -2.27
                        },
                        {
                            name: 'POL',
                            'v1': 0.54
                        },
                        {
                            name: 'UK',
                            'v1': 0.85
                        }
                    ]
                },
                {
                    title: '8. SENSE OF BELONGING',
                    description: 'Sense of Belonging scores are derived from measures of a sense of ethnic minority attachment to one’s neighbourhood, village/town/city, county/region, and country. The score further includes measures of the level of identification with one’s country of residence amongst ethnic minority individuals and the extent to which students from immigrant backgrounds identify with their school.',
                    source: 'EU MIDIS II Database (2016); OECD Report (2017). PISA 2015 RESULTS (VOLUME III): STUDENTS’ WELL-BEING',
                    dataNames: ['Sense of Belonging Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.5
                        },
                        {
                            name: 'DNK',
                            'v1': -0.37
                        },
                        {
                            name: 'FRA',
                            'v1': 0.2
                        },
                        {
                            name: 'DEU',
                            'v1': 0.47
                        },
                        {
                            name: 'GRC',
                            'v1': 0.25
                        },
                        {
                            name: 'HUN',
                            'v1': 0.25
                        },
                        {
                            name: 'ITA',
                            'v1': -0.59
                        },
                        {
                            name: 'NLD',
                            'v1': -0.91
                        },
                        {
                            name: 'POL',
                            'v1': -0.23
                        },
                        {
                            name: 'UK',
                            'v1': 0.5
                        }
                    ]
                },
                {
                    title: '9. EQUAL OPPORTUNITIES',
                    description: 'Equal Opportunity scores are derived from measures of the perception that an individual’s ethnicity or skin colour should not disadvantage them as a job candidate, the lack of a gap between ethnic minority individuals and the general population attaining upper level education, and the lack of a gap between ethnic minority individuals and the general population in paid work.',
                    source: 'EC Special Eurobarometer Report on Discrimination (2015, p. 80); EU-MIDIS II (2016); EU-MIDIS II main report (2016, pp. 90-91 and pp. 96-97)',
                    dataNames: ['Equal Opportunities Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.53
                        },
                        {
                            name: 'DNK',
                            'v1': -0.43
                        },
                        {
                            name: 'FRA',
                            'v1': 0.42
                        },
                        {
                            name: 'DEU',
                            'v1': -0.02
                        },
                        {
                            name: 'GRC',
                            'v1': -0.16
                        },
                        {
                            name: 'HUN',
                            'v1': -1.11
                        },
                        {
                            name: 'ITA',
                            'v1': 0.78
                        },
                        {
                            name: 'NLD',
                            'v1': -0.6
                        },
                        {
                            name: 'POL',
                            'v1': 0.83
                        },
                        {
                            name: 'UK',
                            'v1': 0.53
                        }
                    ]
                }
                ]
        }
    },
    {
        polarisation: {
            title: 'Breakdown of Polarisation Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given polarisation indicator group (i.e. it is less polarised on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given polarisation indicator group (i.e. it is more polarised on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [{
                title: 'INDICATOR GROUP 1: POLITICAL INJUSTICE',
                description: 'Political Injustice scores are derived from measures of the level of restriction placed on members of religious groups and their lack of freedom to follow their religious practices and beliefs.',
                source: 'PEW Research Center Report (2016, pp. 55-56): Global Uptick in Government Restrictions on Religion; PEW Research Center Report (2015, p. 60-61). Latest Trends in Religious Restrictions and Hostilities; Freedom House (2019). Freedom in the World Report: Civil Liberties, D. Freedom of Expression and Belief, Question D2; V-DEM Database (2018)',
                dataNames: ['Political Injustice Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.51
                        },
                        {
                            name: 'DNK',
                            'v1': 0.01
                        },
                        {
                            name: 'FRA',
                            'v1': 0.97
                        },
                        {
                            name: 'DEU',
                            'v1': 0.3
                        },
                        {
                            name: 'GRC',
                            'v1': 0.73
                        },
                        {
                            name: 'HUN',
                            'v1': -0.28
                        },
                        {
                            name: 'ITA',
                            'v1': -0.43
                        },
                        {
                            name: 'NLD',
                            'v1': -0.92
                        },
                        {
                            name: 'POL',
                            'v1': -0.12
                        },
                        {
                            name: 'UK',
                            'v1': -0.77
                        }]
            },
            {
                title: 'INDICATOR GROUP 2: MAINSTREAM DISENGAGEMENT',
                description: 'Mainstream Disengagement scores are derived from measures of religious minority (specifically, Muslim community) distrust in a country`s parliament, legal system, police, politicians, and political parties. *Please note: scores for Hungary (HU) and Poland (PL) appear at zero because there is currently no comparable data for these countries.',
                source: 'EU-MIDIS II Database (2016): Figures drawn from groups and countries in which Muslims were surveyed; see also EU-MIDIS II (2016) ; FRA. (2017, p. 56). Second European Union Minorities and Discrimination Survey: Muslims.',
                dataNames: ['Mainstream Disengagement Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.17
                        },
                        {
                            name: 'DNK',
                            'v1': 0.70
                        },
                        {
                            name: 'FRA',
                            'v1': 0.63
                        },
                        {
                            name: 'DEU',
                            'v1': -1.08
                        },
                        {
                            name: 'GRC',
                            'v1': -1.34
                        },
                        {
                            name: 'HUN',
                            'v1': 0.00
                        },
                        {
                            name: 'ITA',
                            'v1': 0.87
                        },
                        {
                            name: 'NLD',
                            'v1': 0.75
                        },
                        {
                            name: 'POL',
                            'v1': 0.00
                        },
                        {
                            name: 'UK',
                            'v1': -0.69
                        }]
            },
            {
                title: 'INDICATOR GROUP 3: ANTAGONISTIC ENVIRONMENT',
                description: 'Antagonistic Environment scores are derived from measures of harassment or physical attacks against individuals wearing religious clothing and a measure of the country`s level of social hostility. *Please note: scores for Hungary (HU) and Poland (PL) appear at zero because there is currently no comparable data for these countries.',
                source: 'EU MIDIS II Database (2016); PEW Research Center Report (2015, p. 60-61). Latest Trends in Religious Restrictions and Hostilities.',
                dataNames: ['Antagonistic Environment Score'],
                data: [{
                            name: 'BEL',
                            'v1': -0.46
                        },
                        {
                            name: 'DNK',
                            'v1': 0.32
                        },
                        {
                            name: 'FRA',
                            'v1': 0.55
                        },
                        {
                            name: 'DEU',
                            'v1': 0.58
                        },
                        {
                            name: 'GRC',
                            'v1': 0.44
                        },
                        {
                            name: 'HUN',
                            'v1': 0.00
                        },
                        {
                            name: 'ITA',
                            'v1': -0.41
                        },
                        {
                            name: 'NLD',
                            'v1': 0.11
                        },
                        {
                            name: 'POL',
                            'v1': 0.00
                        },
                        {
                            name: 'UK',
                            'v1': -0.67
                        }]
            },
            {
                title: 'INDICATOR GROUP 4: ONLINE POLARISATION',
                description: 'Online Polarisation scores are derived from a measure of the level of cyber-harassment experienced by individuals in countries in which religious minority individuals (specifically, Muslim community members) have been surveyed. *Please note: scores for Hungary (HU) and Poland (PL) appear at zero because there is currently no comparable data for these countries.',
                source: 'EU MIDIS II Database (2016); see also FRA. (2017, p. 45). Second European Union Minorities and Discrimination Survey: Muslims.',
                dataNames: ['Online Polarisation Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.05
                        },
                        {
                            name: 'DNK',
                            'v1': 0.55
                        },
                        {
                            name: 'FRA',
                            'v1': 0.05
                        },
                        {
                            name: 'DEU',
                            'v1': 0.55
                        },
                        {
                            name: 'GRC',
                            'v1': -1.2
                        },
                        {
                            name: 'HUN',
                            'v1': 0.00
                        },
                        {
                            name: 'ITA',
                            'v1': -0.87
                        },
                        {
                            name: 'NLD',
                            'v1': 1.81
                        },
                        {
                            name: 'POL',
                            'v1': 0.00
                        },
                        {
                            name: 'UK',
                            'v1': -0.95
                        }]
            },
            {
                title: 'INDICATOR GROUP 5: EXCLUSIONARY IDENTITIES',
                description: 'Exclusionary Identity scores are derived from measures of the level of discomfort felt by members of various religions in working with or having love relationships with members of other religions. This category further includes measures of the level of general public discomfort with a minority religion political leader, having Muslims as neighbours, and having Muslims as a member of the family. In addition, measures of ethnic minority discomfort with a neighbour of a different religion and discomfort with a family member marrying someone of a different religion are also included.',
                source: 'EC Special Eurobarometer Report on Discrimination (2015); EU MIDIS II Database (2016); FRA Report. (2017, p. 22). Second European Union Minorities and Discrimination Survey: Muslims; PEW Research Center Report (2018, p. 3): Eastern and Western Europeans Differ on Importance of Religion, Views of Minorities, and Key Social Issues.',
                dataNames: ['Exclusionary Identities Score'],
                data: [{
                            name: 'BEL',
                            'v1': -0.34
                        },
                        {
                            name: 'DNK',
                            'v1': -0.5
                        },
                        {
                            name: 'FRA',
                            'v1': -0.79
                        },
                        {
                            name: 'DEU',
                            'v1': -0.02
                        },
                        {
                            name: 'GRC',
                            'v1': 1.34
                        },
                        {
                            name: 'HUN',
                            'v1': 0.71
                        },
                        {
                            name: 'ITA',
                            'v1': 0.29
                        },
                        {
                            name: 'NLD',
                            'v1': -0.62
                        },
                        {
                            name: 'POL',
                            'v1': 0.71
                        },
                        {
                            name: 'UK',
                            'v1': -0.67
                        }]
            },
            {
                title: 'INDICATOR GROUP 6: DISCRIMINATION',
                description: 'Discrimination scores are derived from measures of perceived levels of discrimination against members of religious groups.',
                source: 'EC Special Eurobarometer Report on Discrimination (2015, p. T9 and p. 70); EU-MIDIS II Database (2016); MIPEX Database (2015).',
                dataNames: ['Discrimination Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.87
                        },
                        {
                            name: 'DNK',
                            'v1': -0.08
                        },
                        {
                            name: 'FRA',
                            'v1': 1
                        },
                        {
                            name: 'DEU',
                            'v1': 0.05
                        },
                        {
                            name: 'GRC',
                            'v1': -1.01
                        },
                        {
                            name: 'HUN',
                            'v1': -0.91
                        },
                        {
                            name: 'ITA',
                            'v1': 0.17
                        },
                        {
                            name: 'NLD',
                            'v1': 0.53
                        },
                        {
                            name: 'POL',
                            'v1': -1.2
                        },
                        {
                            name: 'UK',
                            'v1': 0.57
                        }]
            }]
        },
        resilience: {
            title: 'Breakdown of Resilience Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given resilience indicator group (i.e. it is less resilient on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given resilience indicator group (i.e. it is more resilient on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [{
                title: 'INDICATOR GROUP 1: POSITIVE WELL-BEING',
                description: 'Positive Well-Being is derived from measures of the extent to which members identifying as a member of a religious group rate themselves as being happy, as having someone to discuss intimate personal matters with, as having a good standard of general health, and as engaging in social activities.',
                source: 'European Social Survey (average value across surveys in 2010, 2012, 2014, 2016 and 2018)',
                dataNames: ['Positive Well-Being Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.11
                        },
                        {
                            name: 'DNK',
                            'v1': 0.42
                        },
                        {
                            name: 'FRA',
                            'v1': 0.47
                        },
                        {
                            name: 'DEU',
                            'v1': 0.66
                        },
                        {
                            name: 'GRC',
                            'v1': -1.73
                        },
                        {
                            name: 'HUN',
                            'v1': -0.52
                        },
                        {
                            name: 'ITA',
                            'v1': -0.21
                        },
                        {
                            name: 'NLD',
                            'v1': 0.66
                        },
                        {
                            name: 'POL',
                            'v1': -0.05
                        },
                        {
                            name: 'UK',
                            'v1': 0.19
                        }]
            },
            {
                title: 'INDICATOR GROUP 2: COMMUNITY ENGAGEMENT',
                description: 'Community Engagement scores are derived from a measure of the perception that minority religions are being engaged in efforts to fight economic crisis and promote recovery.',
                source: 'QC15.5 from the EC Special Eurobarometer Report on Discrimination (2015, p. T238)',
                dataNames: ['Community Engagement Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.25
                        },
                        {
                            name: 'DNK',
                            'v1': 0.25
                        },
                        {
                            name: 'FRA',
                            'v1': -1.21
                        },
                        {
                            name: 'DEU',
                            'v1': 0.87
                        },
                        {
                            name: 'GRC',
                            'v1': 0.87
                        },
                        {
                            name: 'HUN',
                            'v1': 1.08
                        },
                        {
                            name: 'ITA',
                            'v1': -0.79
                        },
                        {
                            name: 'NLD',
                            'v1': 1.08
                        },
                        {
                            name: 'POL',
                            'v1': -1.21
                        },
                        {
                            name: 'UK',
                            'v1': -1.21
                        }]
            },
            {
                title: 'INDICATOR GROUP 3: SOCIAL INCLUSION',
                description: 'Social Inclusion scores are derived from a measure of the number of Muslim members in the European Parliament.',
                source: 'ENAR Election Analysis:  https://www.enar-eu.org/ENAR-s-Election-Analysis-Ethnic-minorities-in-the-new-European-Parliament-2019',
                dataNames: ['Social Inclusion Score'],
                data: [{
                            name: 'BEL',
                            'v1': -0.52
                        },
                        {
                            name: 'DNK',
                            'v1': -0.52
                        },
                        {
                            name: 'FRA',
                            'v1': 0.97
                        },
                        {
                            name: 'DEU',
                            'v1': 0.22
                        },
                        {
                            name: 'GRC',
                            'v1': -0.52
                        },
                        {
                            name: 'HUN',
                            'v1': -0.52
                        },
                        {
                            name: 'ITA',
                            'v1': -0.52
                        },
                        {
                            name: 'NLD',
                            'v1': -0.52
                        },
                        {
                            name: 'POL',
                            'v1': -0.52
                        },
                        {
                            name: 'UK',
                            'v1': 2.47
                        }]
            },
            {
                title: 'INDICATOR GROUP 4: DEMOCRATIC REPORTING',
                description: 'Democratic Reporting scores are derived from measures of the perception that differing religions and beliefs are sufficiently reflected in the media, that antisemitism in the country’s media is not a big problem, that the country’s media system is classified as democratic or liberal, and that the country’s media discourse has not been rated as containing incitement against religious minorities.',
                source: 'QC12.3 from the EC Special Eurobarometer Report on Discrimination (2015, p. T113); FRA Antisemitism Survey Data Explorer (2012); STOA Report on Polarisation and the News Media in Europe (2019, p. 15); FRA Report on Incitement in Media Content and Political Discourse in EU Member States (2016, pp. 12-13).',
                dataNames: ['Democratic Reporting Score'],
                data: [{
                            name: 'BEL',
                            'v1': -0.09
                        },
                        {
                            name: 'DNK',
                            'v1': 0.18
                        },
                        {
                            name: 'FRA',
                            'v1': -0.5
                        },
                        {
                            name: 'DEU',
                            'v1': 0.64
                        },
                        {
                            name: 'GRC',
                            'v1': -0.34
                        },
                        {
                            name: 'HUN',
                            'v1': -1.02
                        },
                        {
                            name: 'ITA',
                            'v1': -0.12
                        },
                        {
                            name: 'NLD',
                            'v1': 0.41
                        },
                        {
                            name: 'POL',
                            'v1': 0
                        },
                        {
                            name: 'UK',
                            'v1': 0.9
                        }]
            },
            {
                title: 'INDICATOR GROUP 5: COMMUNITY COHESION',
                description: 'Community Cohesion scores are derived from measures of ethnic minorities having friends of a different religion and general population within the country having friends of a different religion.',
                source: 'EU-MIDIS II Database (2016); SD1.5 from the EC Special Eurobarometer Report on Discrimination (2012, p. T95)',
                dataNames: ['Community Cohesion Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.52
                        },
                        {
                            name: 'DNK',
                            'v1': 0.44
                        },
                        {
                            name: 'FRA',
                            'v1': 0.86
                        },
                        {
                            name: 'DEU',
                            'v1': 0.62
                        },
                        {
                            name: 'GRC',
                            'v1': -1.83
                        },
                        {
                            name: 'HUN',
                            'v1': -0.48
                        },
                        {
                            name: 'ITA',
                            'v1': -0.27
                        },
                        {
                            name: 'NLD',
                            'v1': 0.61
                        },
                        {
                            name: 'POL',
                            'v1': -1.28
                        },
                        {
                            name: 'UK',
                            'v1': 0.81
                        }]
            },
            {
                title: 'INDICATOR GROUP 6: SUPPORTIVE ENVIRONMENT',
                description: 'Supportive Environment scores are derived from measures of perceptions that workplaces are making efforts to promote religious diversity and that school lessons should include information on religious diversity.',
                source: 'QC7R.6 from the EC Special Eurobarometer Report on Discrimination (2015, p. T92); QC17.1 from the EC Special Eurobarometer Report on Discrimination (2015, p. T250)',
                dataNames: ['Supportive Environment Score'],
                data: [{
                            name: 'BEL',
                            'v1': 0.23
                        },
                        {
                            name: 'DNK',
                            'v1': 0.44
                        },
                        {
                            name: 'FRA',
                            'v1': -0.64
                        },
                        {
                            name: 'DEU',
                            'v1': 0.79
                        },
                        {
                            name: 'GRC',
                            'v1': -0.24
                        },
                        {
                            name: 'HUN',
                            'v1': -1
                        },
                        {
                            name: 'ITA',
                            'v1': -0.5
                        },
                        {
                            name: 'NLD',
                            'v1': 0.62
                        },
                        {
                            name: 'POL',
                            'v1': -1.13
                        },
                        {
                            name: 'UK',
                            'v1': 1.44
                        }]
            },
            {
                title: 'INDICATOR GROUP 7: POSITIVE IMAGE ONLINE',
                description: 'Positive Image Online scores are derived from measures of the perception that antisemitism on the internet is not a big problem within the country and zero experience of finding offensive comments on the internet in countries in which Muslims have been surveyed. *Please note: the score for Poland (PL) appears at zero because there is currently no comparable data for this country.',
                source: 'EU-MIDIS II Database (2016); FRA Antisemitism Survey Data Explorer (2012).',
                dataNames: ['Positive Image Online Score'],
                data: [{
                            name: 'BEL',
                            'v1': -0.6
                        },
                        {
                            name: 'DNK',
                            'v1': -0.24
                        },
                        {
                            name: 'FRA',
                            'v1': -0.35
                        },
                        {
                            name: 'DEU',
                            'v1': 0.42
                        },
                        {
                            name: 'GRC',
                            'v1': 1.2
                        },
                        {
                            name: 'HUN',
                            'v1': -0.28
                        },
                        {
                            name: 'ITA',
                            'v1': 0.01
                        },
                        {
                            name: 'NLD',
                            'v1': -1.96
                        },
                        {
                            name: 'POL',
                            'v1': 0.00
                        },
                        {
                            name: 'UK',
                            'v1': 1.16
                        }]
            },
            {
                title: 'INDICATOR GROUP 8: SENSE OF BELONGING',
                description: 'Sense of Belonging is derived from a measure of the perception that religion creates a sense of community within the country.',
                source: 'QD5 from the EC Standard Eurobarometer 89 Report (2018, p. 44)',
                dataNames: ['Sense of Belonging Score'],
                data: [{
                            name: 'BEL',
                            'v1': -0.32
                        },
                        {
                            name: 'DNK',
                            'v1': -1.62
                        },
                        {
                            name: 'FRA',
                            'v1': 0
                        },
                        {
                            name: 'DEU',
                            'v1': -0.32
                        },
                        {
                            name: 'GRC',
                            'v1': 1.62
                        },
                        {
                            name: 'HUN',
                            'v1': 1.29
                        },
                        {
                            name: 'ITA',
                            'v1': 0.32
                        },
                        {
                            name: 'NLD',
                            'v1': -0.97
                        },
                        {
                            name: 'POL',
                            'v1': 0.65
                        },
                        {
                            name: 'UK',
                            'v1': -0.65
                        }]
            },
            {
                title: 'INDICATOR GROUP 9: EQUAL OPPORTUNITIES',
                description: 'Equal Opportunity is derived from a measure of the perception that the expression of an individual`s religious belief would not disadvantage a job candidate.',
                source: 'QC3 from the EC Special Eurobarometer Report on Discrimination (2015, p. 80)',
                dataNames: ['Equal Opportunities Score'],
                data: [{
                            name: 'BEL',
                            'v1': -0.78
                        },
                        {
                            name: 'DNK',
                            'v1': -0.95
                        },
                        {
                            name: 'FRA',
                            'v1': -0.56
                        },
                        {
                            name: 'DEU',
                            'v1': -0.56
                        },
                        {
                            name: 'GRC',
                            'v1': 0.78
                        },
                        {
                            name: 'HUN',
                            'v1': 1.26
                        },
                        {
                            name: 'ITA',
                            'v1': 0.91
                        },
                        {
                            name: 'NLD',
                            'v1': -1.6
                        },
                        {
                            name: 'POL',
                            'v1': 1.04
                        },
                        {
                            name: 'UK',
                            'v1': 0.44
                        }]
            }]
        }
    },
    {
        polarisation: {
            title: 'Breakdown of Polarisation Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given polarisation indicator group (i.e. it is less polarised on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given polarisation indicator group (i.e. it is more polarised on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [
                {
                    title: 'INDICATOR GROUP 1: POLITICAL INJUSTICE',
                    description: 'Political Injustice scores are derived from measures of the general public’s perception of the situation within their country and how they feel democracy is working within their country.',
                    source: 'Standard Eurobarometer 90 Report (2018, p. 59 and p. 66); Pew Research Center Report (2019). Dissatisfaction with the Performance of Democracy.',
                    dataNames: ['Political Injustice Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.41
                        },
                        {
                            name: 'DNK',
                            'v1': -0.75
                        },
                        {
                            name: 'FRA',
                            'v1': 0.65
                        },
                        {
                            name: 'DEU',
                            'v1': -0.53
                        },
                        {
                            name: 'GRC',
                            'v1': 1.8
                        },
                        {
                            name: 'HUN',
                            'v1': -0.12
                        },
                        {
                            name: 'ITA',
                            'v1': 0.83
                        },
                        {
                            name: 'NLD',
                            'v1': -1.22
                        },
                        {
                            name: 'POL',
                            'v1': -0.67
                        },
                        {
                            name: 'UK',
                            'v1': 0.33
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 2: MAINSTREAM DISENGAGEMENT',
                    description: 'Mainstream Disengagement scores are derived from measures of the general public’s level of distrust in their government, parliament, political parties, regional local authorities, public administration, army, police, and legal system.',
                    source: 'Standard Eurobarometer 90 Report (2018)',
                    dataNames: ['Mainstream Disengagement Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.32
                        },
                        {
                            name: 'DNK',
                            'v1': -1.17
                        },
                        {
                            name: 'FRA',
                            'v1': 0.27
                        },
                        {
                            name: 'DEU',
                            'v1': -0.77
                        },
                        {
                            name: 'GRC',
                            'v1': 1.36
                        },
                        {
                            name: 'HUN',
                            'v1': 0.27
                        },
                        {
                            name: 'ITA',
                            'v1': 1.06
                        },
                        {
                            name: 'NLD',
                            'v1': -1.16
                        },
                        {
                            name: 'POL',
                            'v1': 0.56
                        },
                        {
                            name: 'UK',
                            'v1': -0.09
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 3: ANTAGONISTIC ENVIRONMENT',
                    description: 'Antagonistic Environment scores are derived from a range of measures, including the country’s conflict score, use of hate speech as part of political rhetoric, strength of in-party versus out-party evaluations, the extent to which the manifesto of the ruling party contains right-wing language, the extent of societal differences on key political issues, the extent to which the current government promotes a specific ideology, the likelihood that posting political content would result in arrest, and the extent to which the government and political parties are rated as disseminating misleading information.',
                    source: 'Global Peace Index (2019, p. 15); Reiljan, A. (2019). ‘Fear and loathing across party lines’(also) in Europe: Affective polarisation in European party systems. European Journal of Political Research; Manifesto Project: https://visuals.manifesto-project.wzb.eu/mpdb-shiny/cmp_dashboard_dataset/ (sorted by indicator [rile] - right-left position); V-DEM Database (2018)',
                    dataNames: ['Antagonistic Environment Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.11
                        },
                        {
                            name: 'DNK',
                            'v1': 0.28
                        },
                        {
                            name: 'FRA',
                            'v1': 0.05
                        },
                        {
                            name: 'DEU',
                            'v1': 0.12
                        },
                        {
                            name: 'GRC',
                            'v1': 0.33
                        },
                        {
                            name: 'HUN',
                            'v1': -0.25
                        },
                        {
                            name: 'ITA',
                            'v1': -0.09
                        },
                        {
                            name: 'NLD',
                            'v1': -0.17
                        },
                        {
                            name: 'POL',
                            'v1': -0.3
                        },
                        {
                            name: 'UK',
                            'v1': -0.09
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 4: ONLINE POLARISATION',
                    description: 'Online Polarisation scores are derived from measures of the extent to which online media outlets provide a range of perspectives and presentations.',
                    source: 'V-Dem Database (2018)',
                    dataNames: ['Online Polarisation Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.22
                        },
                        {
                            name: 'DNK',
                            'v1': -1.56
                        },
                        {
                            name: 'FRA',
                            'v1': -1.12
                        },
                        {
                            name: 'DEU',
                            'v1': -0.05
                        },
                        {
                            name: 'GRC',
                            'v1': -0.27
                        },
                        {
                            name: 'HUN',
                            'v1': 1.98
                        },
                        {
                            name: 'ITA',
                            'v1': 1.2
                        },
                        {
                            name: 'NLD',
                            'v1': 0.67
                        },
                        {
                            name: 'POL',
                            'v1': -0.64
                        },
                        {
                            name: 'UK',
                            'v1': 0.34
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 5: ACTIVE REDRESS',
                    description: 'Active Redress scores are derived from a measure of the number of nationalist party seats obtained in European Parliamentary Elections. *Please note: The judgement of what is and is not determined to be a ‘nationalist’ party can be found in the stated source below.',
                    source: 'Guardian News Report on European Parliament election outcome (2019): https://www.theguardian.com/world/ng-interactive/2019/may/26/eu-election-results-2019-across-europe',
                    dataNames: ['Active Redress Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.3
                        },
                        {
                            name: 'DNK',
                            'v1': -0.18
                        },
                        {
                            name: 'FRA',
                            'v1': 1.42
                        },
                        {
                            name: 'DEU',
                            'v1': 0.09
                        },
                        {
                            name: 'GRC',
                            'v1': -0.73
                        },
                        {
                            name: 'HUN',
                            'v1': -0.73
                        },
                        {
                            name: 'ITA',
                            'v1': 2.04
                        },
                        {
                            name: 'NLD',
                            'v1': -0.73
                        },
                        {
                            name: 'POL',
                            'v1': -0.73
                        },
                        {
                            name: 'UK',
                            'v1': -0.73
                        }
                    ]
                }
            ]
        },
        resilience: {
            title: ' Breakdown of Resilience Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given resilience indicator group (i.e. it is less resilient on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given resilience indicator group (i.e. it is more resilient on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [{
                    title: 'INDICATOR GROUP 1: POSITIVE POLITICAL ENGAGEMENT SCORE',
                    description: 'Positive Political Engagement scores are derived from the country’s political interest index.',
                    source: 'Standard Eurobarometer 90 Report (2018, p. 38)',
                    dataNames: ['Positive Political Engagement Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -1.13
                        },
                        {
                            name: 'DNK',
                            'v1': -0.03
                        },
                        {
                            name: 'FRA',
                            'v1': -0.81
                        },
                        {
                            name: 'DEU',
                            'v1': 1.06
                        },
                        {
                            name: 'GRC',
                            'v1': 1.85
                        },
                        {
                            name: 'HUN',
                            'v1': -0.97
                        },
                        {
                            name: 'ITA',
                            'v1': -0.5
                        },
                        {
                            name: 'NLD',
                            'v1': 0.91
                        },
                        {
                            name: 'POL',
                            'v1': -0.66
                        },
                        {
                            name: 'UK',
                            'v1': 0.28
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 2: DEMOCRATIC REPORTING',
                    description: 'Democratic Reporting scores are derived from measures of general public perceptions that their media report political issues fairly, the extent to which print and broadcast media represent a range of political perspectives and routinely criticise the government, and low levels of media bias against opposition parties.',
                    source: 'PEW Research Centre Report on bias in the media (2018); V-DEM Database (2018)',
                    dataNames: ['Democratic Reporting Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.07
                        },
                        {
                            name: 'DNK',
                            'v1': -0.24
                        },
                        {
                            name: 'FRA',
                            'v1': -0.12
                        },
                        {
                            name: 'DEU',
                            'v1': 0.42
                        },
                        {
                            name: 'GRC',
                            'v1': -0.05
                        },
                        {
                            name: 'HUN',
                            'v1': -0.5
                        },
                        {
                            name: 'ITA',
                            'v1': 0.17
                        },
                        {
                            name: 'NLD',
                            'v1': 0.35
                        },
                        {
                            name: 'POL',
                            'v1': -0.22
                        },
                        {
                            name: 'UK',
                            'v1': 0.26
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 3: SOCIAL INCLUSION',
                    description: 'Social Inclusion scores are derived from measures of the country’s range of political groups and parties represented within the European parliament and low levels of political exclusion based on an individual’s identification with a particular political group.',
                    source: 'Guardian News Report on European Parliament election outcome (2019): https://www.theguardian.com/world/ng-interactive/2019/may/26/eu-election-results-2019-across-europe; V-DEM Database (2018)',
                    dataNames: ['Social Inclusion Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 1.1
                        },
                        {
                            name: 'DNK',
                            'v1': 1.49
                        },
                        {
                            name: 'FRA',
                            'v1': -0.47
                        },
                        {
                            name: 'DEU',
                            'v1': -0.2
                        },
                        {
                            name: 'GRC',
                            'v1': -0.1
                        },
                        {
                            name: 'HUN',
                            'v1': -0.81
                        },
                        {
                            name: 'ITA',
                            'v1': -0.38
                        },
                        {
                            name: 'NLD',
                            'v1': 0.49
                        },
                        {
                            name: 'POL',
                            'v1': -0.65
                        },
                        {
                            name: 'UK',
                            'v1': -0.46
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 4: SENSE OF BELONGING',
                    description: 'Sense of Belonging scores are derived from measures of the general public’s sense of attachment to the town/city/village and country.',
                    source: 'Standard Eurobarometer 89 Report (2018, pp. 6-7)',
                    dataNames: ['Sense of Belonging Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -1.22
                        },
                        {
                            name: 'DNK',
                            'v1': 1.02
                        },
                        {
                            name: 'FRA',
                            'v1': -0.6
                        },
                        {
                            name: 'DEU',
                            'v1': 0.03
                        },
                        {
                            name: 'GRC',
                            'v1': 1.72
                        },
                        {
                            name: 'HUN',
                            'v1': 0.46
                        },
                        {
                            name: 'ITA',
                            'v1': -0.36
                        },
                        {
                            name: 'NLD',
                            'v1': -1.26
                        },
                        {
                            name: 'POL',
                            'v1': 0.59
                        },
                        {
                            name: 'UK',
                            'v1': -0.37
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 5: SUPPORTIVE ENVIRONMENT',
                    description: 'Supportive Environment scores are derived from measures of the civic rights of individuals within the country and the extent to which political elites respect counter-arguments.',
                    source: 'CIVICUS State of Civil Society Report (2019); V-DEM Database (2018)',
                    dataNames: ['Supportive Environment Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.52
                        },
                        {
                            name: 'DNK',
                            'v1': 0.44
                        },
                        {
                            name: 'FRA',
                            'v1': 0.86
                        },
                        {
                            name: 'DEU',
                            'v1': 0.62
                        },
                        {
                            name: 'GRC',
                            'v1': -1.83
                        },
                        {
                            name: 'HUN',
                            'v1': -0.48
                        },
                        {
                            name: 'ITA',
                            'v1': -0.27
                        },
                        {
                            name: 'NLD',
                            'v1': 0.61
                        },
                        {
                            name: 'POL',
                            'v1': -1.28
                        },
                        {
                            name: 'UK',
                            'v1': 0.81
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 6: AGENCY',
                    description: 'Agency scores are derived from measures of individuals’ perceived levels of freedom within their country, the country’s Freedom in the World score, a low Political Rights Restriction score, and the extent to which the government respects press/media, academic and cultural freedom.',
                    source: 'Gallop World Poll (2017); Freedom House Report (2019); V-DEM Database 2018',
                    dataNames: ['Agency Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.56
                        },
                        {
                            name: 'DNK',
                            'v1': 0.78
                        },
                        {
                            name: 'FRA',
                            'v1': 0.37
                        },
                        {
                            name: 'DEU',
                            'v1': 0.47
                        },
                        {
                            name: 'GRC',
                            'v1': -0.59
                        },
                        {
                            name: 'HUN',
                            'v1': -1.93
                        },
                        {
                            name: 'ITA',
                            'v1': -0.01
                        },
                        {
                            name: 'NLD',
                            'v1': 0.71
                        },
                        {
                            name: 'POL',
                            'v1': -0.77
                        },
                        {
                            name: 'UK',
                            'v1': 0.4
                        }
                    ]
                }
                ]
        }
    },
    {
        polarisation: {
            title: 'Breakdown of Polarisation Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given polarisation indicator group (i.e. it is less polarised on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given polarisation indicator group (i.e. it is more polarised on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [
                {
                    title: 'INDICATOR GROUP 1: POLITICAL INJUSTICE',
                    description: 'Political Injustice scores are derived from a variety of measures, including a perception within the LGBT community that they are unable to legally marry, the country’s same-sex marriage score, lack of awareness of laws and political initiatives to protect women from violence, perception that there is no law to forbid discrimination on the grounds of sexual orientation or gender identity, and perceptions that transgender, transsexual and those of a different sexual orientation to the majority are being excluded from measures to fight economic crises.',
                    source: 'EC Survey on Fundamental Rights of Lesbian, Gay, Bisexual and Transgender People in EU (2012); Pew Research Center Report (2019): Where Europe Stands on Gay Marriage and Civil Unions; FRA Report (2014): Violence Againt Women: an EU-Wide Survey; Special Eurobarometer 437 Report on Discrimination (2015)',
                    dataNames: ['Political Injustice Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.59
                        },
                        {
                            name: 'DNK',
                            'v1': -0.93
                        },
                        {
                            name: 'FRA',
                            'v1': -0.49
                        },
                        {
                            name: 'DEU',
                            'v1': -0.25
                        },
                        {
                            name: 'GRC',
                            'v1': 0.7
                        },
                        {
                            name: 'HUN',
                            'v1': 0.59
                        },
                        {
                            name: 'ITA',
                            'v1': 1.58
                        },
                        {
                            name: 'NLD',
                            'v1': -0.86
                        },
                        {
                            name: 'POL',
                            'v1': 0.71
                        },
                        {
                            name: 'UK',
                            'v1': -0.46
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 2: DISCRIMINATION',
                    description: 'Discrimination scores are derived from measures of perceived widespread discrimination on the grounds of gender, gender identity and sexual orientation, as well as personal experiences of discrimination on the grounds of gender, gender identity and sexual orientation.',
                    source: 'Special Eurobarometer 437 Report on Discrimination (2015)',
                    dataNames: ['Discrimination Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.24
                        },
                        {
                            name: 'DNK',
                            'v1': -0.69
                        },
                        {
                            name: 'FRA',
                            'v1': 0.35
                        },
                        {
                            name: 'DEU',
                            'v1': -0.4
                        },
                        {
                            name: 'GRC',
                            'v1': 0.09
                        },
                        {
                            name: 'HUN',
                            'v1': 0.16
                        },
                        {
                            name: 'ITA',
                            'v1': 1.39
                        },
                        {
                            name: 'NLD',
                            'v1': -0.4
                        },
                        {
                            name: 'POL',
                            'v1': -0.68
                        },
                        {
                            name: 'UK',
                            'v1': 0.22
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 3: EXCLUSIVE IDENTITIES',
                    description: 'Exclusive Identity scores are derived from measures of the level of discomfort felt around having a woman, transgender or transsexual person, or LGB person in the highest political office in the country, level of discomfort working with transgender, transsexual or LGB individuals, level of discomfort with a family member dating someone of the same sex or a transgender or transsexual person, level of discomfort with public displays of affection between same sex couples, and level of discomfort with transgender or transsexual individuals changing their civic documents to their inner gender identity.',
                    source: 'Special Eurobarometer 437 Report on Discrimination (2015)',
                    dataNames: ['Exclusive Identities Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.62
                        },
                        {
                            name: 'DNK',
                            'v1': -0.93
                        },
                        {
                            name: 'FRA',
                            'v1': -0.4
                        },
                        {
                            name: 'DEU',
                            'v1': -0.17
                        },
                        {
                            name: 'GRC',
                            'v1': 1.61
                        },
                        {
                            name: 'HUN',
                            'v1': 1.22
                        },
                        {
                            name: 'ITA',
                            'v1': 0.14
                        },
                        {
                            name: 'NLD',
                            'v1': -1.16
                        },
                        {
                            name: 'POL',
                            'v1': 0.95
                        },
                        {
                            name: 'UK',
                            'v1': -0.64
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 4: ONLINE POLARISATION',
                    description: 'Online Polarisation scores are derived from measures of reports of harassment on the internet within a 12 month period based on one’s LGBT identity.',
                    source: 'EC Survey on Fundamental Rights of Lesbian, Gay, Bisexual and Transgender People in EU (2012)',
                    dataNames: ['Online Polarisation Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -1.12
                        },
                        {
                            name: 'DNK',
                            'v1': -0.09
                        },
                        {
                            name: 'FRA',
                            'v1': -0.25
                        },
                        {
                            name: 'DEU',
                            'v1': -0.68
                        },
                        {
                            name: 'GRC',
                            'v1': 2.56
                        },
                        {
                            name: 'HUN',
                            'v1': 0.23
                        },
                        {
                            name: 'ITA',
                            'v1': -0.09
                        },
                        {
                            name: 'NLD',
                            'v1': -0.55
                        },
                        {
                            name: 'POL',
                            'v1': -0.06
                        },
                        {
                            name: 'UK',
                            'v1': 0.05
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 5: ANTAGONISTIC ENVIRONMENT',
                    description: 'Antagonistic Environment scores are derived from measures of LGBT individuals experiencing 10 or more instances of in-person harassment in a 12 month period, physical, sexual attack or threat of violence based on LGBT identity, and avoidance of public contact, certain locations, or being open about one’s sexuality or gender identity due to fear of violence.',
                    source: 'EC Survey on Fundamental Rights of Lesbian, Gay, Bisexual and Transgender People in EU (2012)',
                    dataNames: ['Antagonistic Environment Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.21
                        },
                        {
                            name: 'DNK',
                            'v1': -1.26
                        },
                        {
                            name: 'FRA',
                            'v1': 0.1
                        },
                        {
                            name: 'DEU',
                            'v1': -0.88
                        },
                        {
                            name: 'GRC',
                            'v1': 0.19
                        },
                        {
                            name: 'HUN',
                            'v1': 0.92
                        },
                        {
                            name: 'ITA',
                            'v1': 0.39
                        },
                        {
                            name: 'NLD',
                            'v1': -0.39
                        },
                        {
                            name: 'POL',
                            'v1': 1.06
                        },
                        {
                            name: 'UK',
                            'v1': 0.09
                        }
                    ]
                }
            ]
        },
        resilience: {
            title: 'Breakdown of Resilience Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given resilience indicator group (i.e. it is less resilient on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given resilience indicator group (i.e. it is more resilient on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [
                {
                    title: 'INDICATOR GROUP 1: SOCIAL INCLUSION SCORE',
                    description: 'Social Inclusion scores are derived from measures of the proportion of women in the European Parliament and single/lower houses of parliament, the extent to which public figures are open about their sexuality or gender identity, and the extent of political exclusion by gender.',
                    source: 'EC Report (2019). Equality Between Men and Women; EC Survey on Fundamental Rights of Lesbian, Gay, Bisexual and Transgender People in EU (2012); V-DEM Database (2018)',
                    dataNames: ['Social Inclusion Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.65
                        },
                        {
                            name: 'DNK',
                            'v1': 0.85
                        },
                        {
                            name: 'FRA',
                            'v1': -0.31
                        },
                        {
                            name: 'DEU',
                            'v1': 0.38
                        },
                        {
                            name: 'GRC',
                            'v1': -0.77
                        },
                        {
                            name: 'HUN',
                            'v1': -0.96
                        },
                        {
                            name: 'ITA',
                            'v1': -0.04
                        },
                        {
                            name: 'NLD',
                            'v1': 0.89
                        },
                        {
                            name: 'POL',
                            'v1': -0.58
                        },
                        {
                            name: 'UK',
                            'v1': -0.1
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 2: DEMOCRATIC REPORTING',
                    description: 'Democratic Reporting scores are derived from measures of the perception that differing genders, LGB individuals and transgender or transsexual individuals are sufficiently reflected in the media, the country’s media and political discourse has not been rated as containing incitement against sexual minorities, and the country’s media system is classified as democratic or liberal.',
                    source: 'EC Special Eurobarometer Report on Discrimination (2015); FRA Report on Incitement in Media Content and Political Discourse in EU Member States (2016); STOA Report on Polarisation and the News Media in Europe (2019)',
                    dataNames: ['Democratic Reporting Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.52
                        },
                        {
                            name: 'DNK',
                            'v1': 0.28
                        },
                        {
                            name: 'FRA',
                            'v1': -0.55
                        },
                        {
                            name: 'DEU',
                            'v1': 0.59
                        },
                        {
                            name: 'GRC',
                            'v1': -0.66
                        },
                        {
                            name: 'HUN',
                            'v1': -0.7
                        },
                        {
                            name: 'ITA',
                            'v1': -0.27
                        },
                        {
                            name: 'NLD',
                            'v1': 0.26
                        },
                        {
                            name: 'POL',
                            'v1': -0.35
                        },
                        {
                            name: 'UK',
                            'v1': 0.87
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 3: SUPPORTIVE ENVIRONMENT',
                    description: 'Supportive Environment scores are derived from measures of individuals favouring same sex marriage, lack of opposition amongst young adults to gay marriage, belief in equality of rights between LGBT and heterosexual individuals, belief that there is nothing wrong with a sexual relationship between members of the same sex, belief that same sex marriages should be allowed throughout Europe, perception that one’s workplace is making efforts to promote gender, gender identity and sexual orientation diversity, and agreement that schools should offer materials on gender identity and sexual orientation.',
                    source: 'PEW Research Center Report; Special Eurobarometer 437 Report on Discrimination (2015)',
                    dataNames: ['Supportive Environment Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.53
                        },
                        {
                            name: 'DNK',
                            'v1': 0.76
                        },
                        {
                            name: 'FRA',
                            'v1': 0.03
                        },
                        {
                            name: 'DEU',
                            'v1': 0.29
                        },
                        {
                            name: 'GRC',
                            'v1': -0.67
                        },
                        {
                            name: 'HUN',
                            'v1': -0.96
                        },
                        {
                            name: 'ITA',
                            'v1': -0.32
                        },
                        {
                            name: 'NLD',
                            'v1': 0.99
                        },
                        {
                            name: 'POL',
                            'v1': -1.28
                        },
                        {
                            name: 'UK',
                            'v1': 0.63
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 4: POSITIVE IMAGE ONLINE',
                    description: 'Positive Image Online scores are derived from measures of below average recordings of offensive terms relating to gender or sexual orientation being found on the internet.',
                    source: 'Hatebase (2019): https://hatebase.org/recent_sightings',
                    dataNames: ['Positive Image Online Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.69
                        },
                        {
                            name: 'DNK',
                            'v1': 0.69
                        },
                        {
                            name: 'FRA',
                            'v1': -0.15
                        },
                        {
                            name: 'DEU',
                            'v1': -0.62
                        },
                        {
                            name: 'GRC',
                            'v1': 0.69
                        },
                        {
                            name: 'HUN',
                            'v1': 0.57
                        },
                        {
                            name: 'ITA',
                            'v1': -1.37
                        },
                        {
                            name: 'NLD',
                            'v1': 0.69
                        },
                        {
                            name: 'POL',
                            'v1': -1.48
                        },
                        {
                            name: 'UK',
                            'v1': 0.28
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 5: POSITIVE WELL-BEING',
                    description: 'Positive Well-Being scores are derived from a measure of the LGBT community reporting higher than average levels of satisfaction with life in their country.',
                    source: 'EC Survey on Fundamental Rights of Lesbian, Gay, Bisexual and Transgender People in EU (2012)',
                    dataNames: ['Positive Well-Being Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.81
                        },
                        {
                            name: 'DNK',
                            'v1': 1.23
                        },
                        {
                            name: 'FRA',
                            'v1': -0.03
                        },
                        {
                            name: 'DEU',
                            'v1': 0.53
                        },
                        {
                            name: 'GRC',
                            'v1': -1.29
                        },
                        {
                            name: 'HUN',
                            'v1': -1.01
                        },
                        {
                            name: 'ITA',
                            'v1': -0.87
                        },
                        {
                            name: 'NLD',
                            'v1': 1.23
                        },
                        {
                            name: 'POL',
                            'v1': -1.15
                        },
                        {
                            name: 'UK',
                            'v1': 0.53
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 6: SENSE OF BELONGING',
                    description: 'Sense of Belonging scores are derived from a measure of the extent to which individuals identifying as female identify with the school.',
                    source: 'OECD Report (2017). PISA 2015 RESULTS (VOLUME III): STUDENTS’ WELL-BEING',
                    dataNames: ['Sense of Belonging Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.3
                        },
                        {
                            name: 'DNK',
                            'v1': 0.93
                        },
                        {
                            name: 'FRA',
                            'v1': -0.02
                        },
                        {
                            name: 'DEU',
                            'v1': 1.43
                        },
                        {
                            name: 'GRC',
                            'v1': 0.26
                        },
                        {
                            name: 'HUN',
                            'v1': 0.82
                        },
                        {
                            name: 'ITA',
                            'v1': -0.41
                        },
                        {
                            name: 'NLD',
                            'v1': -0.02
                        },
                        {
                            name: 'POL',
                            'v1': -2.21
                        },
                        {
                            name: 'UK',
                            'v1': -0.47
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 7: EQUAL OPPORTUNITIES',
                    description: 'Equal Opportunities scores are derived from measures of the perception that a person’s gender, gender identity or sexual orientation would not disadvantage them when being selected for a job, lack of a gender pay gap and gender employment gap, and a perception that one’s employment benefits and conditions have not been affected as a result of being LGBT.',
                    source: 'Special Eurobarometer 437 Report on Discrimination (2015); EC Report (2019). Equality Between Men and Women; EC Survey on Fundamental Rights of Lesbian, Gay, Bisexual and Transgender People in EU (2012)',
                    dataNames: ['Equal Opportunities Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.4
                        },
                        {
                            name: 'DNK',
                            'v1': 0.33
                        },
                        {
                            name: 'FRA',
                            'v1': 0.18
                        },
                        {
                            name: 'DEU',
                            'v1': -0.43
                        },
                        {
                            name: 'GRC',
                            'v1': -0.65
                        },
                        {
                            name: 'HUN',
                            'v1': 0.29
                        },
                        {
                            name: 'ITA',
                            'v1': -0.04
                        },
                        {
                            name: 'NLD',
                            'v1': -0.96
                        },
                        {
                            name: 'POL',
                            'v1': 0.53
                        },
                        {
                            name: 'UK',
                            'v1': 0.28
                        }
                    ]
                }
            ]
        }
    },
    {
        polarisation: {
            title: 'Breakdown of Polarisation Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given polarisation indicator group (i.e. it is less polarised on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given polarisation indicator group (i.e. it is more polarised on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [
                {
                    title: 'INDICATOR GROUP 1: SOCIAL DEPRIVATION',
                    description: 'Social Deprivation scores are derived from measures of the general public’s perception of the financial situation of their household and country, public ratings of the economy and employment situation, perceptions that the economy and employment situation will get worse, low GDP, lack of GDP growth, and low levels of educational equality.',
                    source: 'Standard Eurobarometer 90 Report (2018); V-DEM Database (2018)',
                    dataNames: ['Social Deprivation Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.13
                        },
                        {
                            name: 'DNK',
                            'v1': -1.17
                        },
                        {
                            name: 'FRA',
                            'v1': 0.6
                        },
                        {
                            name: 'DEU',
                            'v1': -0.54
                        },
                        {
                            name: 'GRC',
                            'v1': 1.08
                        },
                        {
                            name: 'HUN',
                            'v1': 0.62
                        },
                        {
                            name: 'ITA',
                            'v1': -0.52
                        },
                        {
                            name: 'NLD',
                            'v1': -1.16
                        },
                        {
                            name: 'POL',
                            'v1': 0.23
                        },
                        {
                            name: 'UK',
                            'v1': 0.41
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 2: SOCIAL DISPARITY',
                    description: 'Social Disparity scores are derived from measures of the level of total income share possessed by those in the top 10% of income share and the level of educational inequality.',
                    source: 'World Inequality Report (2018); V-DEM Database (2018)',
                    dataNames: ['Social Disparity Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.39
                        },
                        {
                            name: 'DNK',
                            'v1': -0.62
                        },
                        {
                            name: 'FRA',
                            'v1': 0.53
                        },
                        {
                            name: 'DEU',
                            'v1': 0.45
                        },
                        {
                            name: 'GRC',
                            'v1': 0.58
                        },
                        {
                            name: 'HUN',
                            'v1': -0.97
                        },
                        {
                            name: 'ITA',
                            'v1': -0.24
                        },
                        {
                            name: 'NLD',
                            'v1': -0.69
                        },
                        {
                            name: 'POL',
                            'v1': 1.5
                        },
                        {
                            name: 'UK',
                            'v1': -0.15
                        }
                    ]
                }
            ]
        },
        resilience: {
            title: 'Breakdown of Resilience Scores Across the EU',
            subtitle: 'Countries with negative scores indicate that the country has below EU average scores across measures within a given resilience indicator group (i.e. it is less resilient on that indicator group than the EU average), while countries with positive scores indicate that the country has above EU average scores across measures within a given resilience indicator group (i.e. it is more resilient on that indicator group than the EU average). Please note that these are average scores. Therefore, countries may score above or below average on particular measures within an indicator group. To see a more detailed breakdown of the scores, scroll to the bottom of the page to download the raw data.',
            charts: [
                {
                    title: 'INDICATOR GROUP 1: INVESTMENT SCORE',
                    description: 'Investment scores are derived from measures of businesses who feel that business reforms within their country will have a positive impact on their investment strategy, a low investment barrier score, and the ability of businesses to make all desired investments.',
                    source: 'Flash Eurobarometer 459 Report: Investment in EU Member States (2017)',
                    dataNames: ['Investment Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.1
                        },
                        {
                            name: 'DNK',
                            'v1': 0.55
                        },
                        {
                            name: 'FRA',
                            'v1': 0.24
                        },
                        {
                            name: 'DEU',
                            'v1': 0.2
                        },
                        {
                            name: 'GRC',
                            'v1': -0.33
                        },
                        {
                            name: 'HUN',
                            'v1': 0.45
                        },
                        {
                            name: 'ITA',
                            'v1': -0.88
                        },
                        {
                            name: 'NLD',
                            'v1': 0.64
                        },
                        {
                            name: 'POL',
                            'v1': -0.19
                        },
                        {
                            name: 'UK',
                            'v1': -0.58
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 2: COMMUNITY ENTERPRISE',
                    description: 'Community Enterprise scores are derived from measures of social enterprise within a country, including the number of social enterprises present, policy frameworks and legal recognition for social enterprises, and financial support for community enterprises.',
                    source: 'EC Map of Social Enterprises Report (2015)',
                    dataNames: ['Community Enterprise Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.4
                        },
                        {
                            name: 'DNK',
                            'v1': -0.32
                        },
                        {
                            name: 'FRA',
                            'v1': 0.66
                        },
                        {
                            name: 'DEU',
                            'v1': 0.08
                        },
                        {
                            name: 'GRC',
                            'v1': -0.66
                        },
                        {
                            name: 'HUN',
                            'v1': -0.21
                        },
                        {
                            name: 'ITA',
                            'v1': 0.94
                        },
                        {
                            name: 'NLD',
                            'v1': -0.78
                        },
                        {
                            name: 'POL',
                            'v1': -0.33
                        },
                        {
                            name: 'UK',
                            'v1': 1.02
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 3: SOCIAL INCLUSION',
                    description: 'Social Inclusion scores are derived from a measure of low levels of political exclusion on the grounds of socio-economic status.',
                    source: 'V-DEM Database (2018)',
                    dataNames: ['Social Inclusion Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.13
                        },
                        {
                            name: 'DNK',
                            'v1': 1.09
                        },
                        {
                            name: 'FRA',
                            'v1': 0.13
                        },
                        {
                            name: 'DEU',
                            'v1': 0.9
                        },
                        {
                            name: 'GRC',
                            'v1': -0.63
                        },
                        {
                            name: 'HUN',
                            'v1': -0.82
                        },
                        {
                            name: 'ITA',
                            'v1': 0.13
                        },
                        {
                            name: 'NLD',
                            'v1': 1.09
                        },
                        {
                            name: 'POL',
                            'v1': 0.13
                        },
                        {
                            name: 'UK',
                            'v1': -2.16
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 4: SENSE OF BELONGING',
                    description: 'Sense of Belonging scores are derived from a measure of the extent to which students from an underprivileged background identify with their school.',
                    source: 'OECD Report (2017). PISA 2015 RESULTS (VOLUME III): STUDENTS’ WELL-BEING',
                    dataNames: ['Sense of Belonging Score'],
                    data: [{
                            name: 'BEL',
                            'v1': -0.25
                        },
                        {
                            name: 'DNK',
                            'v1': 1.13
                        },
                        {
                            name: 'FRA',
                            'v1': -0.98
                        },
                        {
                            name: 'DEU',
                            'v1': 1.41
                        },
                        {
                            name: 'GRC',
                            'v1': 0.19
                        },
                        {
                            name: 'HUN',
                            'v1': 0.19
                        },
                        {
                            name: 'ITA',
                            'v1': -0.2
                        },
                        {
                            name: 'NLD',
                            'v1': 0.52
                        },
                        {
                            name: 'POL',
                            'v1': -2.08
                        },
                        {
                            name: 'UK',
                            'v1': 0.08
                        }
                    ]
                },
                {
                    title: 'INDICATOR GROUP 5: POSITIVE WELL-BEING',
                    description: 'Positive Well-Being scores are derived from measures of the extent to which high quality healthcare is guaranteed for all and the country’s world happiness ranking.',
                    source: 'World Happiness Report (2019); V-DEM Database (2018)',
                    dataNames: ['Positive Well-Being Score'],
                    data: [{
                            name: 'BEL',
                            'v1': 0.59
                        },
                        {
                            name: 'DNK',
                            'v1': 0.76
                        },
                        {
                            name: 'FRA',
                            'v1': 0.37
                        },
                        {
                            name: 'DEU',
                            'v1': 0.47
                        },
                        {
                            name: 'GRC',
                            'v1': -1.06
                        },
                        {
                            name: 'HUN',
                            'v1': -1.82
                        },
                        {
                            name: 'ITA',
                            'v1': -0.12
                        },
                        {
                            name: 'NLD',
                            'v1': 1
                        },
                        {
                            name: 'POL',
                            'v1': -0.61
                        },
                        {
                            name: 'UK',
                            'v1': 0.41
                        }
                    ]
                }
            ]
        }
    }
]



// WEBPACK FOOTER //
// ./src/components/ToolkitComponent/chartData.js